import React from "react";
import SidebarButton from "./SidebarButton";
import Logo from "../../Assets/img/LandingPageLogo.png";

const DashboardSidebar = ({ sidebarButtons, isVisible }) => {
  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 w-72 bg-white dark:bg-zinc-900 border-r border-zinc-200 dark:border-zinc-800 transition-transform duration-300 ease-in-out lg:static lg:translate-x-0 flex flex-col ${
        isVisible ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Sidebar Header / Logo */}
      <div className="flex items-center justify-center h-20 border-b border-zinc-200 dark:border-zinc-800 px-6 shrink-0">
        <img src={Logo} alt="Admin Logo" className="h-8 object-contain dark:invert" />
      </div>

      {/* Sidebar Links */}
      <div className="flex-1 overflow-y-auto py-6 px-4 space-y-2">
        <p className="px-4 text-xs font-semibold text-zinc-400 tracking-wider uppercase mb-4">
          Overview
        </p>
        {sidebarButtons && sidebarButtons.map((btn, i) => (
          <SidebarButton key={i} btnObj={btn} />
        ))}
      </div>

      {/* Sidebar Footer */}
      <div className="p-6 border-t border-zinc-200 dark:border-zinc-800 shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center text-zinc-600 dark:text-zinc-300 font-bold">
            A
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-zinc-900 dark:text-white">Admin User</span>
            <span className="text-xs text-zinc-500">Sareh Art Gallery</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default DashboardSidebar;
